import { Filter, Options, Paging, Sorting } from "../models/HttpClientModels";
import { AxiosResponse } from "axios";
import axios from "./axios";
import { parseTemplate } from "url-template";
import AuthenticationModel from "@api/models/AuthenticationModel";
import AuthenticationResponseModel from "@api/models/AuthenticationResponseModel";
import RESTCollectionModelBase from "@api/models/RESTCollectionModelBase";
import { getLocalStorageItem } from "@utils/localStorageUtil";
import { accessTokenKey } from "@const/localStorage";
import RefreshTokenRequestModel from "@api/models/RefreshTokenRequestModel";

export default class HttpClient {
    constructor(endpoint: string, filter: object) {
        this.endpoint = endpoint;

        const filterProperties = Object.keys(filter);
        const filterString = filterProperties.join(",");
        this.filterTemplate = filterString;
    }

    endpoint: string;
    filterTemplate: string;

    findAsync = async <T>(filter: any = {}, paging: Paging = {}, sorting: Sorting = {}, options: Options, optionalUrl = ""): Promise<AxiosResponse<RESTCollectionModelBase<T>>> => {
        const urlTemplate = parseTemplate(`/api/${this.endpoint}/${optionalUrl}/{?${this.filterTemplate},embed,rpp,pageNumber,pageSize,orderBy,ascending}`);
        const endpoint = urlTemplate.expand({
            ...filter,
            ...options,
            ...paging,
            ...sorting
        });

        return await axios.get<RESTCollectionModelBase<T>>(endpoint, authorizationHeaderConfig);
    };

    getAsync = async <T>(id: string, options: Options = {}, optionalUrl = ""): Promise<AxiosResponse<T>> => {
        const rootUrl = `${this.endpoint}/${id}/${optionalUrl}`;

        const urlTemplate = parseTemplate(`/api/${rootUrl}{?embed}`);
        const endPoint = urlTemplate.expand({ ...options });

        return await axios.get<T>(endPoint, authorizationHeaderConfig);
    };

    postAsync = async <T>(model: any, optionalUrl = ""): Promise<AxiosResponse<T>> => {
        return await axios.post<T>(
            `/api/${this.endpoint}/${optionalUrl}`, JSON.stringify(model), authorizationHeaderConfig
        );
    };

    putAsync = async <T>(id: string, model: any, optionalUrl = ""): Promise<AxiosResponse<T>> => {
        return await axios.put<T>(
            `/api/${this.endpoint}/${id}/${optionalUrl}`, model, authorizationHeaderConfig
        );
    };

    getTokenAsync = async (authenticationModel: AuthenticationModel) => {
        return await axios.post<AuthenticationResponseModel>(
            `/api/${this.endpoint}`, authenticationModel, tokenConfig
        );
    };
    getRefreshTokenAsync = async (authenticationModel: RefreshTokenRequestModel) => {
        return await axios.post<AuthenticationResponseModel>(
            `/api/${this.endpoint}`, authenticationModel, tokenConfig
        );
    };
}

const authorizationHeaderConfig = {
    headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Authorization": ""
    }
};

export async function UpdateAuthorizationHeaderConfig() {
    const accessToken = await getLocalStorageItem(accessTokenKey);

    authorizationHeaderConfig.headers.Authorization = `Bearer ${accessToken}`;
}

const tokenConfig = { headers: { "Content-Type": "application/x-www-form-urlencoded" } };
